import HeaderContainer from './header_container';

export default HeaderContainer;
